// /* eslint-disable no-shadow */
// import React, { Component } from "react";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import {
//   loadAgencyPerformance,
//   selectTab,
// } from "../../../actions/employerAnalyticsActions";
// import ErrorBoundary from "../../shared/error/ErrorBoundary";
// import FullScreenLoading from "../../shared/loaders/FullScreenLoading";
// import LeagueTable from "./LeagueTable";
// import PlacementSummary from "./PlacementSummary";
// import FillRate from "./FillRate";
// import TimeToSubmission from "./TimeToSubmission";
// import { Wrapper, Inner, Charts } from "../styles/employer-analytics-styles";

// export interface IAgencyPerformanceProps {
//   selectTab: (tabType: string) => void;
//   loadAgencyPerformance: () => void;
//   loading: boolean;
//   isPremiumOrPortalUser: boolean;
//   hubAdminPresent: boolean;
// }

// export class AgencyPerformance extends Component<
//   IAgencyPerformanceProps,
//   unknown
// > {
//   static propTypes = {
//     loading: PropTypes.bool.isRequired,
//     loadAgencyPerformance: PropTypes.func.isRequired,
//     selectTab: PropTypes.func.isRequired,
//     isPremiumOrPortalUser: PropTypes.bool.isRequired,
//     hubAdminPresent: PropTypes.bool.isRequired,
//   };

//   componentDidMount(): void {
//     const { loadAgencyPerformance, selectTab } = this.props;
//     selectTab("agency");
//     loadAgencyPerformance();
//   }

//   render(): React.ReactNode {
//     const { loading, isPremiumOrPortalUser, hubAdminPresent } = this.props;

//     return (
//       <ErrorBoundary>
//         {loading ? (
//           <FullScreenLoading />
//         ) : (
//           <Wrapper tabs>
//             <Inner agencyPerformance>
//               <Charts
//                 agency
//                 isPremiumOrPortalUser={isPremiumOrPortalUser}
//                 hubAdminPresent={hubAdminPresent}
//               >
//                 <PlacementSummary />
//                 <FillRate />
//                 <TimeToSubmission />
//                 <LeagueTable />
//               </Charts>
//             </Inner>
//           </Wrapper>
//         )}
//       </ErrorBoundary>
//     );
//   }
// }

// interface IReduxState {
//   employerAnalytics: {
//     agencyPerformanceLoading: boolean;
//   };
// }

// const mapStateToProps = (state: IReduxState) => ({
//   loading: state.employerAnalytics.agencyPerformanceLoading,
// });

// export default connect(mapStateToProps, { loadAgencyPerformance, selectTab })(
//   AgencyPerformance
// );
